import { getAppStore } from '~src/app/AppStore';
import { NavLocationSelectors } from '~src/app/selectors/NavigationStateSelectors';
import { SessionSiteSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause, ExplorableItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { SchedulesService } from '~src/ts/resources/Schedules';

export const ScheduleDefinition: ExplorableItemDefinition & SpaceDefinition<'schedule'> = {
  itemType: 'schedule',
  contentType: 'schedule',
  singularName: Messages.schedule,
  pluralName: Messages.schedules,
  emptyStateMessage: Messages.schedulesEmptyMessage,
  contentFilterKeys: [],
  defaultFilters: (_projectId: string) => {
    // if on site schedules page return a siteId filter
    const inServerArea = NavLocationSelectors.inServerArea(getAppStore().getState());
    if (!inServerArea) {
      const siteId: string = SessionSiteSelectors.siteId(getAppStore().getState());
      return {siteId: ServerFilterClauses.serverFilterClauses.siteId(siteId)};
    }
    return undefined;
  },
  cardComponent: GenericCard,
  listViewIconUrl: null,
  headerIconPath: () => imgPath('spaces_masthead_schedule.svg'),
  filterClause: ServerFilterClauses.ContentType(['schedule']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return SchedulesService.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
